import { gql } from 'apollo-angular'

export const GET_EDITION_BY_ID = gql`
  query getEditionById($id: Int!) {
    Edition(id: $id, select: true) {
      id
      edition_version
      title
      volume
      year
      magazine {
        id
      }
      slug
      createdAt
      updatedAt
      published_at
      pdf
    }
  }
`
